import { computed } from 'vue'
import { useVuetify } from '~/useVuetify'

export function useLandingTheme() {
  const { $vuetify } = useVuetify()

  const landingThemeVars = computed(() => {
    const theme = $vuetify.theme.currentTheme
    const isDark = $vuetify.theme.dark

    return {
      '--landing-primary': theme.primary,
      '--landing-secondary': theme.secondary,
      '--landing-accent': theme.accent,
      '--landing-dark': theme.darkBlue,
      '--landing-bg': theme.background,
      '--landing-neutral': theme.neutral,
      '--landing-surface': theme.surface,
      '--landing-on-dark': isDark ? theme.neutral : theme.background,
    }
  })

  return { landingThemeVars }
}
